import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9dd4e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RouteSheetStatus" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_cheap, {
      class: _normalizeClass(["small", _ctx.cheapClasses])
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.status.name), 1)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}